import { supabase } from '../lib/supabase';
import { otpService } from './otpService';

/**
 * Status Guard Service
 * Checks if user has confirmed status before allowing write actions
 */

class StatusGuardService {
  /**
   * Check if user has confirmed status
   * @returns {Promise<{hasAccess: boolean, message?: string}>}
   */
  async checkStatusConfirmation() {
    try {
      // Get current user
      const { data: { user }, error: authError } = await supabase?.auth?.getUser();
      
      if (authError || !user) {
        return {
          hasAccess: false,
          message: 'Morate biti prijavljeni'
        };
      }

      // Check if user has confirmed status
      const result = await otpService?.checkStatusConfirmation();
      
      if (!result?.success) {
        return {
          hasAccess: false,
          message: 'Greška pri proveri statusa'
        };
      }

      if (!result?.data?.hasConfirmedStatus) {
        return {
          hasAccess: false,
          message: 'Morate potvrditi status da biste mogli da objavljujete ponude i pregovarate'
        };
      }

      return {
        hasAccess: true
      };
    } catch (error) {
      console.error('Error checking status confirmation:', error);
      return {
        hasAccess: false,
        message: 'Greška pri proveri statusa'
      };
    }
  }

  /**
   * Guard for write actions (create listing, send message, start negotiation)
   * @param {Function} action - Action to execute if user has access
   * @param {Function} onAccessDenied - Callback when access is denied
   * @returns {Promise<any>}
   */
  async guardWriteAction(action, onAccessDenied) {
    const { hasAccess, message } = await this?.checkStatusConfirmation();
    
    if (!hasAccess) {
      if (onAccessDenied) {
        onAccessDenied(message);
      }
      return null;
    }
    
    return await action();
  }
}

export const statusGuardService = new StatusGuardService();